import { useEffect } from "react";
import $ from "jquery";

function hobbleEffect() {
  $(document)
    .on("mousemove", ".td_hobble", function (event) {
      const el = this as HTMLElement;
      const $el = $(this);

      const halfW = el.clientWidth / 2;
      const halfH = el.clientHeight / 2;

      const offset = $el.offset();
      if (!offset) return;

      const coorX = halfW - (event.pageX - offset.left);
      const coorY = halfH - (event.pageY - offset.top);

      const degX1 = (coorY / halfH) * 8 + "deg";
      const degY1 = (coorX / halfW) * -8 + "deg";

      const degX2 = (coorY / halfH) * -50 + "px";
      const degY2 = (coorX / halfW) * 70 + "px";

      const degX3 = (coorY / halfH) * -15 + "px";
      const degY3 = (coorX / halfW) * 20 + "px";

      const degX4 = (coorY / halfH) * 15 + "deg";
      const degY4 = (coorX / halfW) * -15 + "deg";

      const degX5 = (coorY / halfH) * -20 + "px";
      const degY5 = (coorX / halfW) * 35 + "px";

      $el
        .find(".td_hover_layer_1")
        .css(
          "transform",
          () =>
            `perspective(800px) translate3d(0,0,0) rotateX(${degX1}) rotateY(${degY1})`
        );
      $el
        .find(".td_hover_layer_2")
        .css(
          "transform",
          () => `perspective(800px) translateY(${degX2}) translateX(${degY2})`
        );
      $el
        .find(".td_hover_layer_3")
        .css(
          "transform",
          () => `perspective(800px) translateX(${degX3}) translateY(${degY3})`
        );
      $el
        .find(".td_hover_layer_4")
        .css(
          "transform",
          () =>
            `perspective(800px) translate3d(0,0,0) rotateX(${degX4}) rotateY(${degY4})`
        );
      $el
        .find(".td_hover_layer_5")
        .css(
          "transform",
          () => `perspective(800px) translateY(${degX5}) translateX(${degY5})`
        );
    })
    .on("mouseout", ".td_hobble", function () {
      const $el = $(this);
      $el.find(".td_hover_layer_1").removeAttr("style");
      $el.find(".td_hover_layer_2").removeAttr("style");
      $el.find(".td_hover_layer_3").removeAttr("style");
      $el.find(".td_hover_layer_4").removeAttr("style");
      $el.find(".td_hover_layer_5").removeAttr("style");
    });
}

export const useHobble = (): void => {
  useEffect(() => {
    try {
      hobbleEffect();
    } catch (error) {
      console.error("Error in hobble effect:", error);
    }
  }, []);
};
